import { ApplicationConfig, provideBrowserGlobalErrorListeners } from '@angular/core'
import { provideRouter, TitleStrategy } from '@angular/router'
import { provideHttpClient, withInterceptors } from '@angular/common/http'

import { routes } from './app.routes'
import { AppTitleStrategy } from './services/app-title-strategy'
import { authInterceptor } from './services/auth.interceptor'
import { retailAuthInterceptor } from './retail/retail-auth.interceptor'

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
    provideHttpClient(withInterceptors([authInterceptor, retailAuthInterceptor])),
    { provide: TitleStrategy, useClass: AppTitleStrategy },
  ],
}
